export default __webpack_public_path__ + "static/media/03.b555d65d.jpg";